<template>
  <div class="admin-layout">
    <!-- Side Navigation Bar -->
    <Navbar/>

    <!-- Main Content Area -->
    <div class="admin-content">
      <header class="admin-header">
        <h1>Admin Dashboard</h1>
        <div class="user-profile">
          <span>Welcome, Admin</span>
          <i class="fas fa-user-circle"></i>
        </div>
      </header>

      <main class="dashboard">
        <section class="stats-cards">
          <div class="stat-card">
            <div class="stat-icon"><i class="fas fa-shopping-cart"></i></div>
            <div class="stat-info">
              <h3>128</h3>
              <p>Total Orders</p>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-icon"><i class="fas fa-dollar-sign"></i></div>
            <div class="stat-info">
              <h3>$8,240</h3>
              <p>Revenue</p>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-icon"><i class="fas fa-box"></i></div>
            <div class="stat-info">
              <h3>36</h3>
              <p>Products</p>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-icon"><i class="fas fa-users"></i></div>
            <div class="stat-info">
              <h3>842</h3>
              <p>Customers</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase";
import { signOut } from "firebase/auth";
import Navbar from '../Header/Navbar.vue'

export default {
  name: 'Admin',
  data() {
    return {
      recentOrders: [
        { id: '1089', customer: 'John Doe', date: '18 Apr 2025', amount: '148.99', status: 'Completed' },
        { id: '1088', customer: 'Sarah Williams', date: '17 Apr 2025', amount: '79.95', status: 'Processing' },
        { id: '1087', customer: 'Alex Johnson', date: '16 Apr 2025', amount: '242.00', status: 'Completed' },
        { id: '1086', customer: 'Linda Smith', date: '15 Apr 2025', amount: '365.80', status: 'Shipped' },
        { id: '1085', customer: 'Michael Brown', date: '14 Apr 2025', amount: '124.50', status: 'Pending' }
      ]
    };
  },
  metaInfo() {
    return {
      title: "Admin Dashboard | ShopT"
    };
  },
  components: {
    Navbar
  },
  methods: {
    async logout() {
      try {
        await signOut(auth);
        this.$router.push("/login");
      } catch (error) {
        console.error("Error signing out: ", error);
      }
    }
  }
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  min-height: 100vh;
  background-color: #111;
  color: #fff;
}

/* Main Content Styles */
.admin-content {
  flex: 1;
  padding: 0;
  overflow-y: auto;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background-color: #111;
  border-bottom: 1px solid #333;
}

.admin-header h1 {
  font-size: 1.8rem;
  font-weight: 500;
  margin: 0;
}

.user-profile {
  display: flex;
  align-items: center;
}

.user-profile span {
  margin-right: 10px;
  font-weight: 500;
}

.user-profile i {
  font-size: 1.5rem;
  color: #ccc;
}

/* Dashboard Styles */
.dashboard {
  padding: 90px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stats-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); /* Kartlar yan yana sıralanacak */
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background-color: #222;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  align-items: center;
  border: 1px solid #444;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  background-color: purple;
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.stat-icon i {
  font-size: 1.5rem;
  color: #fff;
}

.stat-info h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: #fff;
}

.stat-info p {
  font-size: 0.9rem;
  color: #999;
  margin: 5px 0 0 0;
}

.recent-orders {
  background-color: #222;
  border-radius: 10px;
  padding: 20px;
  border: 1px solid #444;
}

.recent-orders h2 {
  font-size: 1.5rem;
  margin: 0 0 20px 0;
  font-weight: 500;
}

.order-table {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background-color: #333;
}

th, td {
  padding: 12px 15px;
  text-align: left;
}

th {
  font-weight: 500;
  color: #ccc;
}

tbody tr {
  border-bottom: 1px solid #444;
}

tbody tr:last-child {
  border-bottom: none;
}

.status-completed {
  background-color: rgba(39, 174, 96, 0.2);
  color: #2ecc71;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
}

.status-processing {
  background-color: rgba(241, 196, 15, 0.2);
  color: #f1c40f;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
}

.status-shipped {
  background-color: rgba(52, 152, 219, 0.2);
  color: #3498db;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
}

.status-pending {
  background-color: rgba(231, 76, 60, 0.2);
  color: #e74c3c;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
}

@media (max-width: 768px) {
  .admin-layout {
    flex-direction: column;
  }

  .admin-sidebar {
    width: 100%;
    height: auto;
    border-right: none;
    border-bottom: 2px solid purple;
  }

  .sidebar-nav a {
    padding: 10px 20px;
  }

  .stats-cards {
    grid-template-columns: 1fr;
  }
}
</style>